import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../pages/landing/sections/TopBar";
import Footer from "../pages/landing/sections/Footer";
import { usePageTitle } from "../../hooks/dynamic_title/usePageTitle";

const LandingPageLayout = () => {
  usePageTitle();
  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      <TopBar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default LandingPageLayout;
